import React, {useEffect, useState, memo} from 'react';
import {Button, Form, Input, Table, Select, Space, Modal, Spin} from "antd";
import {getGridTableHeight, isEmpty} from '../Common/util';
import {EditableCell, EditableRow} from '../Common/function';
import CodeSelect from '../Common/CodeSelect';
import { analySelectOptions } from '../Common/options';
import SelectBox from '../Common/SelectBox';

/** --------------------------- ----------------------------------------------- **/
const AnalysisTable = ({data, columnData, reportId, reportInfo, isLoading, onClickSaveHandler, rowSelection, spinflag, pagination, onChangeHandler, onDataChange}) => {
 
//----------------------------------------------------------------------------------------

    // 변수 선언
    const [form] = Form.useForm();
    const [dataSource, setDataSource] = useState(data);
    const [deleteData, setDeleteData] = useState([]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const [totalCount, setTotalCount] = useState(0);
    const [totalPage, setTotalPage] = useState(1);

    // const [currentPage, setCurrentPage] = useState(1);
    // const pageSize = 100;

    //확정여부
    const confirmed = reportInfo.confirm=='Y'?true:false;
    const analySelectOptionsNew = [{text: '선택해 주세요', value: ''}, ...analySelectOptions.slice(1)];
    let changeData = [];

    useEffect(() => {
      setDataSource(data);
      setDeleteData([]);
    }, [data]);

    // useEffect(() => {
    //     // 데이터를 청크(chunk)로 나누어 처리
    //     const startIndex = (currentPage - 1) * pageSize;
    //     const endIndex = startIndex + pageSize;
    //     setDataSource(data.slice(startIndex, endIndex));
    //         setDeleteData([]);
    // }, [data, currentPage]);
    
    // const handleTableChange = (pagination) => {
    //     setCurrentPage(pagination.current);
    // };

    const operationColumns = [
      {
        key: 'operation',
        width: '0px',
        defualt: '',
      },
    ];

    // 미확정상태의 경우 operation칼럼 추가 및 edit기능 추가
    let mergedColumns = [];
    
    if(!confirmed) {
      const columns = [...columnData];
      operationColumns.map((col) => {
        columns.push(col);
      });

      mergedColumns = columns.map((col) => {
        if (!col.editable) {
          return col;
        }
        return {
          ...col,
          onCell: (record) => ({
            record,
            editable: col.editable,
            dataIndex: col.dataIndex,
            title: col.title,
            handleSave,
          }),
        };
      });
    } else {
      mergedColumns = [...columnData];
    }

    //행 저장
    const handleSave = (row) => {
      const newData = [...dataSource];
      const index = newData.findIndex((item) => row.id == item.id);
      const item = newData[index];

      if(JSON.stringify(item) != JSON.stringify(row)) {
        row.operation = row.id=='0'?'C':'U';
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        setDataSource(newData);
        // 상위 컴포넌트에 변경사항 전달
        if (onDataChange) {
          onDataChange(newData);
        }
      }
    };

    useEffect(() => {
        //저장,수정 대상 추가
        const newData = dataSource.filter((item) => item.operation && item.operation != '');
        changeData = [];

        newData.map((record) => {
          if(record.operation && record.operation != '') {
            changeData = changeData.concat(record);
          }
        })

    }, [dataSource]);

  //----------------------------------------------------------------------------------------
    // 진단결과 일괄수정을 위한 수정값
    const [applyResultCd, setApplyResultCd] = useState('');
    const [applyRemark, setApplyRemark] = useState('');

    // 진단결과 일괄수정
    const onClickApplyHandler = () => {
      if(isEmpty(applyResultCd) || isEmpty(applyRemark)) {
        Modal.info({title: "적용하고자 하는 진단결과와 수정사유를 입력하세요. "});
        return;
      }
      //console.log(rowSelection.selectedRowKeys);
      if(isEmpty(rowSelection.selectedRowKeys) || rowSelection.selectedRowKeys.length == 0) {
        Modal.info({title: "적용하고자 하는 대상을 선택해주세요. "});
        return;
      }
      const newData = [...dataSource];
      newData.map((list) => {
        if(rowSelection.selectedRowKeys.indexOf(list.id) > -1) {
          list.operation='U';
          list.result_cd=applyResultCd;
          list.remark=applyRemark;
        }
      })
      setDataSource(newData);
      // 상위 컴포넌트에 변경사항 전달
      if (onDataChange) {
        onDataChange(newData);
      }
    };

    // 진단결과 수정하고 저장 안한 상태로 페이지를 이동할 때 001
    // 체크하는 로직 (진행중) 
    const onPageChangeWrap = (newPage, newPageSize) => {
      let confirmResult = true;

      if( changeData.length > 0 || deleteData.length > 0){ 
        confirmResult = confirm("저장 안된 데이터가 있습니다. 이동하시 겠습니까?");
      }
      
      if (!confirmResult) return;
      
      onChangeHandler(newPage, newPageSize);
    };
    //////////////////////////////////////////////////////// 001
  //----------------------------------------------------------------------------------------
    return (
      <Spin size={"large"}  tip={"Loading..."} spinning={spinflag} >
            {!confirmed ? (
                <table className='search'>
                  <colgroup>
                        <col style={{width:'10%'}} />
                        <col style={{width:'7%'}} />
                        <col style={{width:'15%'}} />
                        <col style={{width:'7%'}} />
                        <col style={{width:'15%'}} />
                        <col style={{width:'10%'}} />
                        <col  />
                        <col style={{width:'10%'}} />
                    </colgroup>
                  <tbody>
                  <tr>
                    {/* <td><div style={{marginLeft:'20px'}}>총 항목수 : {dataSource?.length} 개</div></td>
                    { dataSource?.length > 0 ? ( */}
                    <td><div style={{marginLeft:'20px'}}>총 항목수 : {pagination.total} 개</div></td>
                    { pagination.total > 0 ? (
                      <>
                      <th>진단결과</th>
                      <td>
                        {/* <CodeSelect codeType="result_cd" 
                                        id="applyResultCd"
                                        value={applyResultCd}
                                        disabled={false}
                                        onChangeHandler={(value) => {setApplyResultCd(value)}}
                            /> */}
                        <SelectBox 
                            tag='result_cd' 
                            id="applyResultCd"
                            options={analySelectOptionsNew} 
                            value={applyResultCd}  
                            disabled={false}
                            onChangeHandler={(value) => {setApplyResultCd(value)}} />         
                      </td>
                      <th>수정내용</th>
                      <td><Input id="applyRemark" size="small"
                                    allowClear
                                    value={applyRemark}
                                    onChange={(event) => {setApplyRemark(event.target.value)}}
                                  />
                      </td>
                      <th>
                        <Button type="default" onClick={onClickApplyHandler}>
                                일괄적용
                        </Button>
                      </th>
                      <td>
                        <span style={{color : '#0378c7'}}>※ 진단결과가 SELF로 된 건에 대하여 Y또는 N으로 조정해 주세요.</span>
                      </td>
                      <td style={{textAlign:'right', paddingRight: '33px'}}>
                        <Button type="primary" onClick={()=>onClickSaveHandler(changeData.concat(deleteData))}>
                                진단결과 수정
                        </Button>
                      </td>
                      </>
                    ) : (
                      <></>
                    )}
                  </tr></tbody>
                </table>
                ) : (
                  <></>
                )}
                <Form form={form} component={false}>
                  <Table
                        columns={mergedColumns}
                        dataSource={dataSource}
                        scroll={{y: getGridTableHeight(370)}}
                        loading={{
                            size: "large",
                            spinning: isLoading
                        }}

                        pagination={pagination}
                        
                        // pagination={{
                        //   current: 1,
                        //   showSizeChanger: true,
                        //   showQuickJumper: true,
                        //   showTotal: (total, range) =>
                        //     `${range[0]}-${range[1]} of ${total} items`,
                        //   pageSizeOptions: ['10', '20', '50', '100'],
                        //   position: ['bottomCenter'], 
                        //   // defaultPageSize:[100],
                        // }}
                        // pagination={{position: ['bottomCenter'], defaultPageSize:[100]}}
                        // pagination={{
                        //     current: currentPage,
                        //     pageSize: pageSize,
                        //     total: data.length,
                        //     simple: true,
                        //     showSizeChanger: false  // 페이지 사이즈 변경 옵션 비활성화
                        // }}
                        // onChange={handleTableChange}
                        bordered size={"small"}
                        showSorterTooltip={false}
                        components={{
                          body: {
                            row: EditableRow,
                            cell: EditableCell,
                          },
                        }}
                        rowClassName={() => 'editable-row'}
                        rowSelection={confirmed?null:{
                          type: 'checkbox',
                          ...rowSelection,
                        }}
                  />
                </Form>
        </Spin>

    );
}
export default AnalysisTable;   